import { EnumOption } from "./enum-option"

export const ReminderFrequency = {
    Daily: 0,
    Weekly: 1,
    Monthly: 2,
}

export const ReminderFrequencyList: EnumOption[] = [
    { value: ReminderFrequency.Daily, label: 'Daily' },
    { value: ReminderFrequency.Weekly, label: 'Weekly' },
    { value: ReminderFrequency.Monthly, label: 'Monthly' },
]
